import { type PropsWithChildren } from "react";
import { TableHead, cn } from "ui";

import {
  PINNED_CELL,
  PINNED_CELL_FADE,
} from "src/components/pinnedTableCell.shared";

interface PinnedTableHeadProps extends PropsWithChildren {
  fade: boolean;
  className?: string;
}

export function PinnedTableHead(props: PinnedTableHeadProps) {
  return (
    <TableHead
      className={cn(
        PINNED_CELL,
        "bg-background",
        props.fade && cn(PINNED_CELL_FADE, "before:to-background"),
        props.className,
      )}
    >
      {props.children}
    </TableHead>
  );
}
